import { AnyAction } from '@reduxjs/toolkit';
import * as entityHandlers from '../../../modules/bin/entityHandlers';
import { GridOptions } from '../../../components/common/grid/gridOptions';
import ColumnModel from '../../../components/common/grid/columnModel';
import { Record } from '../../../modules/bin/utility';
import { CLEAR } from '../../../modules/general';
import update from '../../../helpers/update';
import { List as ListConstants } from '../../../constants';
import {
  eventOrganizerColumnData,
  eventOrganizerDefaultOrderBy,
  eventOrganizersAvailableFiltersKeys,
} from '../../../constants/eventOrganizer';
import {
  EVENT_ORGANIZERS_METADATA_REQUESTED,
  EVENT_ORGANIZERS_METADATA_SUCCESS,
  EVENT_ORGANIZERS_METADATA_FAILURE,
  EVENT_ORGANIZERS_LIST_DATA_REQUESTED,
  EVENT_ORGANIZERS_LIST_DATA_SUCCESS,
  EVENT_ORGANIZERS_LIST_DATA_FAILURE,
  EVENT_ORGANIZERS_CREATE_REQUESTED,
  EVENT_ORGANIZERS_CREATE_SUCCESS,
  EVENT_ORGANIZERS_CREATE_FAILURE,
  EVENT_ORGANIZERS_UPDATE_REQUESTED,
  EVENT_ORGANIZERS_UPDATE_SUCCESS,
  EVENT_ORGANIZERS_UPDATE_FAILURE,
  EVENT_ORGANIZERS_GET_REQUESTED,
  EVENT_ORGANIZERS_GET_SUCCESS,
  EVENT_ORGANIZERS_GET_FAILURE,
  EVENT_ORGANIZERS_DELETE_REQUESTED,
  EVENT_ORGANIZERS_DELETE_SUCCESS,
  EVENT_ORGANIZERS_DELETE_FAILURE,
  EVENT_ORGANIZERS_MESSAGE_CLEAR,
} from './eventOrganizerTypes';

const initialState = {
  timestamp: new Date().getTime(),
  eventOrganizersList: new GridOptions()
    .addColumns(
      eventOrganizerColumnData.map((x) =>
        new ColumnModel(x.path, x.header, x.customFormatter).setVisible(x.defaultVisible)
      )
    )
    .orderBy(eventOrganizerDefaultOrderBy.path, eventOrganizerDefaultOrderBy.order)
    .addAvailableFiltersKeys(eventOrganizersAvailableFiltersKeys)
    .getState(),
  record: Record.getDefaultState(),
  recordCreate: Record.getDefaultState(),
  recordEdit: Record.getDefaultState(),
  recordDelete: Record.getDefaultState(),
};

const eventOrganizerReducer = (state = initialState, action: AnyAction) => {
  let newState = state;
  switch (action.type) {
    case CLEAR:
      newState = initialState;
      break;

    case EVENT_ORGANIZERS_METADATA_REQUESTED:
      newState = entityHandlers.metadataRequestedHandler(state, action);
      break;
    case EVENT_ORGANIZERS_METADATA_SUCCESS:
      newState = entityHandlers.metadataSuccessHandler(state, action);
      break;
    case EVENT_ORGANIZERS_LIST_DATA_REQUESTED:
      newState = entityHandlers.listDataRequestedHandler(state, action);
      break;
    case EVENT_ORGANIZERS_LIST_DATA_SUCCESS:
      newState = entityHandlers.listDataSuccessHandler(state, action);
      break;
    case EVENT_ORGANIZERS_LIST_DATA_FAILURE:
      newState = entityHandlers.listDataFailureHandler(state, action);
      break;
    case EVENT_ORGANIZERS_MESSAGE_CLEAR:
      newState = entityHandlers.crudClearErrorHandler(state, action.payload.key);
      break;
    case EVENT_ORGANIZERS_METADATA_FAILURE:
      newState = entityHandlers.listMetadataFailureHandler(state, action);
      break;
    case EVENT_ORGANIZERS_CREATE_REQUESTED:
    case EVENT_ORGANIZERS_UPDATE_REQUESTED:
    case EVENT_ORGANIZERS_GET_REQUESTED:
    case EVENT_ORGANIZERS_DELETE_REQUESTED:
      newState = entityHandlers.getRecordRequestedHandler(state, action);
      break;
    case EVENT_ORGANIZERS_CREATE_SUCCESS:
    case EVENT_ORGANIZERS_UPDATE_SUCCESS:
    case EVENT_ORGANIZERS_DELETE_SUCCESS:
      newState = entityHandlers.getRecordSuccessHandler(state, action);
      newState = update.set(newState, 'eventOrganizersList.ready', ListConstants.LIST_STATUS_NO_DATA);
      break;
    case EVENT_ORGANIZERS_GET_SUCCESS:
      newState = entityHandlers.getRecordSuccessHandler(state, action);
      break;
    case EVENT_ORGANIZERS_CREATE_FAILURE:
    case EVENT_ORGANIZERS_UPDATE_FAILURE:
    case EVENT_ORGANIZERS_GET_FAILURE:
    case EVENT_ORGANIZERS_DELETE_FAILURE:
      newState = entityHandlers.crudErrorHandler(state, action);
      break;
    default:
      break;
  }
  return newState;
};

export default eventOrganizerReducer;
